'use strict'

/**
 *
 * @name: nnSeriesSwiper
 *
 */

import DirectiveTemplate from './nn-series-swiper.directive.html'
import './nn-series-swiper.directive.scss'

function NnSeriesSwiperDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '=',
      options: '=*',
      moduleTitle: '=*',
      showSubtitle: '=*',
      theme: '=*'
    },
    template: DirectiveTemplate,
    controller: nnSeriesSwiperDirectiveController
  }
}

function nnSeriesSwiperDirectiveController ($scope, $rootScope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */


  /*
   *
   * @PUBLIC
   *
   */

  $scope.onAnalyticsClick = post => {
    console.log($scope)
    // window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
    $rootScope.analytics.videoAM('single series', $scope.moduleTitle, post)
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

  $scope.$on('ngRepeatFinished', () => {
    if ($scope.baseSwiper) {
      $scope.baseSwiper.setUpdate()
    }
  })

}

export default NnSeriesSwiperDirective



// WEBPACK FOOTER //
// ./app/components/nn-modules/series/common-components/nn-series-swiper/nn-series-swiper.directive.js